import classnames from 'classnames';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { v4 as uuidv4 } from 'uuid';

const DealsMobileSkeleton = ({ product, featuredProducts }) => {
	return (
		<li
			data-lazy-sku={product.ColourId}
			className={classnames('p-2', {
				'w-1/2': featuredProducts !== 1,
			})}>
			<div className="deals-product bg-white relative rounded-lg border border-solid border-gray-30 p-4 h-full">
				<Skeleton height={40} />

				<div className="flex flex-col">
					<div className="p-4">
						<Skeleton height={200} />
					</div>

					<Skeleton height={40} />

					<div className="pt-2">
						<Skeleton />
						<Skeleton width={150} />
						<Skeleton />
						<Skeleton width={150} />
					</div>

					<Skeleton height={40} />
					<div className="pt-2">
						{new Array(4).fill(0).map(() => (
							<React.Fragment key={uuidv4()}>
								<Skeleton />
								<Skeleton width={150} />
							</React.Fragment>
						))}
					</div>
					<div className="mt-3">
						<Skeleton height={40} count={2} />
					</div>
				</div>
			</div>
		</li>
	);
};

export default DealsMobileSkeleton;
